import { render, staticRenderFns } from "./formCommon.vue?vue&type=template&id=5dacf052&scoped=true"
import script from "./formCommon.vue?vue&type=script&lang=js"
export * from "./formCommon.vue?vue&type=script&lang=js"
import style0 from "./formCommon.vue?vue&type=style&index=0&id=5dacf052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dacf052",
  null
  
)

export default component.exports